import { toLocaleTextAsTime } from "@/shared/lib/datetime";
import { Typography } from "@mui/material";

type Props = {
  date: Date;
  isRead: boolean;
};

export const NotificationTime = ({ date, isRead }: Props) => (
  <Typography fontSize="14px" fontWeight={isRead ? 400 : 700}>
    {toLocaleTextAsTime(date)}
  </Typography>
);
